import React, { useEffect } from "react";
// ANT DESIGN COMPONENTS
import { DatePicker } from "antd";
// MOMENT DATE FORMAT
import moment from "moment";
// I18N TRANSLATION
import { useTranslation } from "react-i18next";
// REDUX
import { useDispatch, useSelector } from "react-redux";
import { updateFilterEndDate } from "../../redux/reports/reportsSlice";
// INTERFACES
import { RootState } from "../../app/store";

function ReportsFilterEndDate({ showDatePicker }: any) {
	// ************************************************ */
	// GLOBAL VARIABLES ******************************* */
	const [t] = useTranslation("global");
	const dispatch = useDispatch();

	// ************************************************ */
	// USE STATE VARIABLES **************************** */

	// ************************************************ */
	// REDUX SLICE VARIABLES ************************** */
	const { filterEndDate, reportResetFilters } = useSelector(
		(state: RootState) => state.report
	);

	// ************************************************ */
	// SERVICES AND API CALLS ************************* */

	// ************************************************ */
	// FUNCTIONS ************************************** */
	const onChangeEndDate = (date: any, dateString: string) => {
		dispatch(updateFilterEndDate(dateString));
	};

	const getDaysInMonth = (year: number, month: number) =>
		new Date(year, month, 0).getDate();

	const getInitialDate = () => {
		const date = new Date();
		const currentYear = date.getFullYear();
		const currentMonth = date.getMonth() + 1;
		const daysInCurrentMonth = getDaysInMonth(currentYear, currentMonth);
		const defaultEndDate = `${currentYear}-${
			currentMonth < 10 ? "0" : ""
		}${currentMonth}-${daysInCurrentMonth}`;
		dispatch(updateFilterEndDate(defaultEndDate));
	};
	// ************************************************ */
	// USE EFFECT ************************************* */
	useEffect(() => {
		getInitialDate();
	}, []);

	useEffect(() => {
		if (reportResetFilters) {
			getInitialDate();
		}
	}, [reportResetFilters]);
	// ************************************************ */
	// COMPONENT ************************************** */
	return (
		<div>
			{showDatePicker && (
				<div>
					<DatePicker
						onChange={onChangeEndDate}
						placeholder={t("general.endDate")}
						format='YYYY-MM-DD'
						className='generalStyles__width100 '
						value={moment(filterEndDate)}
						allowClear={false}
					/>
				</div>
			)}
		</div>
	);
}

export default ReportsFilterEndDate;
